var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSimpleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 213,
    viewBox: "0 0 243 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 0H182C215.7 0 243 27.3 243 61C243 94.7 215.7 122 182 122H61C27.3 122 0 94.7 0 61C0 27.3 27.3 0 61 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 152C60 168.178 66.4268 183.694 77.8665 195.134C89.3062 206.573 104.822 213 121 213C137.178 213 152.694 206.573 164.134 195.134C175.573 183.694 182 168.178 182 152H160C160 162.343 155.891 172.263 148.577 179.577C141.263 186.891 131.343 191 121 191C110.657 191 100.737 186.891 93.4228 179.577C86.1089 172.263 82 162.343 82 152H60Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSimpleWhite);
export default __webpack_public_path__ + "static/media/logo-simple-white.b3cf999ceb734149a4bfcfb00472a000.svg";
export { ForwardRef as ReactComponent };